import { promiseAction } from 'utils/store';

export const PAID_SERVICES_ACTION_TYPES = {
  LOAD_PAID_SERVICES: 'paidServices/LOAD_PAID_SERVICES',
  CREATE_PAID_SERVICES: 'paidServices/CREATE_PAID_SERVICES',
  EDIT_PAID_SERVICES: 'paidServices/EDIT_PAID_SERVICES',
}

export const loadPaidServicesAction = promiseAction(PAID_SERVICES_ACTION_TYPES.LOAD_PAID_SERVICES);
export const createPaidServiceAction = promiseAction(PAID_SERVICES_ACTION_TYPES.CREATE_PAID_SERVICES);
export const editPaidServiceAction = promiseAction(PAID_SERVICES_ACTION_TYPES.EDIT_PAID_SERVICES);